module.exports = ".incidentAccidentPublicPage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: auto;\n  background: url('animation-bg.fe2da1c8ac8f4ecff3be.jpg');\n  background-size: cover;\n  color: #212529; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/incident-accident/public/incident-accident-public.component.scss
// module id = ./src/app/components/incident-accident/public/incident-accident-public.component.scss
// module chunks = main